import { io } from "socket.io-client";

// Use dedicated socket URL if available, otherwise derive from API URL
const API_URL = process.env.REACT_APP_API_URL;
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || API_URL?.replace('/api', '');

console.log('🔗 Socket URL determined:', SOCKET_URL);

export const socket = io(SOCKET_URL, {
  transports: ["websocket", "polling"], // websocket FIRST
  upgrade: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000
});

// 🔥 DEBUGGING: Log all socket events
socket.on('connect', () => {
  console.log('🔌 Frontend Socket Connected:', socket.id);
  console.log('🌐 Socket URL:', SOCKET_URL);
  console.log('📡 Transport:', socket.io.engine.transport.name);
});

socket.on('disconnect', (reason) => {
  console.log('❌ Frontend Socket Disconnected:', reason);
  console.log('🔌 Socket ID was:', socket.id);
});

socket.on('connect_error', (error) => {
  console.log('🚨 Frontend Socket Connection Error:', error.message);
  console.log('🌐 Attempting to connect to:', SOCKET_URL);
});

socket.on('reconnect', (attemptNumber) => {
  console.log('🔄 Frontend Socket Reconnected after', attemptNumber, 'attempts');
  console.log('🔌 New Socket ID:', socket.id);
});

socket.on('reconnect_attempt', (attemptNumber) => {
  console.log('🔄 Frontend Socket Reconnection Attempt:', attemptNumber);
});

socket.on('reconnect_error', (error) => {
  console.log('🚨 Frontend Socket Reconnection Error:', error.message);
});

// 🔥 DEBUGGING: Log all received events
const originalOn = socket.on;
socket.on = function(event, callback) {
  const wrappedCallback = function(...args) {
    console.log(`📥 RECEIVED [socket.on('${event}')] - Data:`, args);
    return callback.apply(this, args);
  };
  return originalOn.call(this, event, wrappedCallback);
};

// 🔥 DEBUGGING: Log all emitted events
const originalEmit = socket.emit;
socket.emit = function(event, ...args) {
  console.log(`📤 EMITTING [socket.emit('${event}')] - Data:`, args);
  return originalEmit.call(this, event, ...args);
};

